'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PushCartDeliveryBar = PushCartDeliveryBar;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _functional = require('../../../utils/functional');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function PushCartDeliveryBar() {
  var config = (0, _reactRedux.useSelector)(function (state) {
    return state.pushCart.deliveryConfig;
  });
  var subtotal = (0, _reactRedux.useSelector)(function (state) {
    return state.pushCart.subtotal;
  });

  var renderMessage = (0, _react.useMemo)(function () {
    var isInFirstTier = subtotal <= config.firstTier.maximum;

    if (isInFirstTier) {
      return config.firstTier.message.replace('[amount]', (0, _functional.formatMoney)(config.secondTier.minimum - subtotal));
    } else {
      return config.secondTier.message;
    }
  }, [config, subtotal]);

  return _react2.default.createElement('div', { className: 'psh-Delivery' }, _react2.default.createElement('p', { className: 'psh-Delivery_Message' }, _react2.default.createElement('span', { className: 'am-icon-shipping psh-Delivery_Icon' }), _react2.default.createElement('span', null, renderMessage)));
}

PushCartDeliveryBar.propTypes = {};